import { render, staticRenderFns } from "./TableTag.vue?vue&type=template&id=5439dfba&scoped=true&"
import script from "./TableTag.vue?vue&type=script&lang=js&"
export * from "./TableTag.vue?vue&type=script&lang=js&"
import style0 from "./TableTag.vue?vue&type=style&index=0&id=5439dfba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5439dfba",
  null
  
)

export default component.exports